//Diferentes spinner para cargar informacion

export const SpinnerEllipsis = () => {
    return (
        <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}
